module.exports = __webpack_public_path__ + "static/media/planet-level11.f7036219.png";